import React from 'react';
import styled from "styled-components";
import {HandleLoginHeader} from "./login";
import ButtonBase from "@atoms/button.base";
import {isEmpty} from "@helpers/helpers";
import Captcha from "./captcha";
import CircleLoading from "../lotties/circle_loading";

function ConfirmCaptcha({level, setShow, fields, setFields, handleVerificationCode, handleContinue, handleChange, handleForceRefreshCaptcha}) {

    const handleResendCode = () => {
        setFields(state => ({
            ...state,
            ['confirm_captcha']: {value: '', error: '', loading: true},
        }));

        handleVerificationCode('code', true);
    };

    return (
        <Container show={level.confirm_captcha}>
            <HandleLoginHeader title="تایید کد امنیتی" close={() => setShow(false)} back={() => handleContinue('mobile')}/>

            {
                (level.confirm_captcha && !isEmpty(fields.captcha.token) && fields.captcha.require) ?
                    <Captcha
                        handleChange={handleChange}
                        token={fields.captcha.token}
                        fields={fields}
                        setFields={setFields}
                        handleForceRefreshCaptcha={handleForceRefreshCaptcha}
                        className="mt-24"
                    />
                    : ''
            }

            <ButtonBase onClick={handleResendCode} color="secondary" block className={"mt-16 "} disabled={fields.confirm_captcha.loading}>
                {
                    (fields.confirm_captcha.loading) ?
                        <CircleLoading width={24} height={24}/>
                        :
                        'تایید'
                }
            </ButtonBase>
        </Container>
    )
}

export default React.memo(ConfirmCaptcha);

// styles
const Container = styled.div`
  display: ${props => props.show ? 'block' : 'none'};
`;
